import BookingResourceCard from './BookingResourceCard';

export default BookingResourceCard;
